import React from 'react';

export default function Notifications() {
    return(
        <div>
            <h1>React Notifications page</h1>
        </div>
    )
}
